import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class AlertMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AlertMetaModule,
            providers: [
                providePageMeta({
                    title: 'Alerts',
                    translationKey: 'page_alerts',
                    routerLink: '/alerts',
                    icon: 'bell',
                    permission: 'Alerts.View',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                }),
            ],
        };
    }
}
